import axios, { AxiosResponse } from 'axios';
import config from '@config';
import forceSessionLogout from 'src/utils/forceSessionLogout';
import { isForceLogoutAuthError } from 'src/utils/isForceLogoutAuthError';

interface ApiOptions {
    withoutExtend?: boolean;
    forceEshopKey?: string;
    customEshopKeyHeader?: string;
    responseType?: 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream';
    headers?: Record<string, string>;
}

// Definice typového aliasu
type ApiFunction = <T = any>(
    method: string,
    url: string,
    data?: any,
    options?: ApiOptions
) => Promise<AxiosResponse<T>>;

const api: ApiFunction = async (method, url, data, options) => {
    let token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    const expiresIn = localStorage.getItem('expiresIn');
    const eshopKey = options?.forceEshopKey || localStorage.getItem('eshopKey');

    if (!options?.withoutExtend && Number(expiresIn) < Date.now()) {
        try {
            const response: AxiosResponse<{ token: string; expiresIn: number; refreshToken: string }> = await axios({
                url: 'api/public/refresh',
                method: 'POST',
                data: { refreshToken },
                baseURL: config.apiUrl,
            });

            token = response.data.token;

            localStorage.setItem('token', response.data.token);
            localStorage.setItem('expiresIn', String(response.data.expiresIn * 1000));
            localStorage.setItem('refreshToken', response.data.refreshToken);
        } catch (error) {
            forceSessionLogout();
        }
    }

    const headers: Record<string, string> = {};
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    if (eshopKey) {
        headers[options?.customEshopKeyHeader || 'Eshop-Key'] = eshopKey;
    }

    let axiosConfig: any = {
        url,
        method,
        data,
        baseURL: config.apiUrl,
        headers: {
            ...headers,
            ...options?.headers,
        },
    };

    if (options?.responseType) {
        axiosConfig.responseType = options.responseType;
        axiosConfig = {
            ...axiosConfig,
            timeout: 0, // Vypneme timeout
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            decompress: false // V
        }
    }

    try {
        return await axios(axiosConfig);
    } catch (error) {
        if (isForceLogoutAuthError(error)) {
            forceSessionLogout();
            return new Promise(() => {});
        }

        throw error;
    }
};

export default api;
